import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { hasValidProps, ROUTES } from 'Utils';
import * as analytics from 'Utils/analytics';
import ProgressBar from 'Components/ProgressBar';
const { EVENTS } = analytics;

const Verification = (props) => {
  const [emailFailed, setEmailFailed] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const { email, strings, transitionTo, uim } = props;

  useEffect(() => {
    if (!hasValidProps(email)) {
      transitionTo(ROUTES.PAGE_HOME.url);
    }
  }, [email]);

  const resendEmail = async () => {
    analytics.event({
      action: EVENTS.resendRegistrationVerification,
      label: 'resendRegistrationVerification',
    });
    setEmailFailed(false);
    setSubmitting(true);
    try {
      await uim.resendRegistrationVerificationEmail(email);
      transitionTo(ROUTES.PAGE_VERIFICATION_SENT.url);
    } catch (e) {
      setSubmitting(false);
      setEmailFailed(true);
      logException(e);
    }
  };

  return (
    <div>
      {submitting && <ProgressBar />}
      <h1 className="page-heading">{strings.verificationRequired}</h1>
      <p className="break-word">
        {strings.verificationMessage.formatUimTranslation(email)}
      </p>
      <div className="sublink" onClick={resendEmail}>
        {strings.resendEmail}
      </div>
      {emailFailed && (
        <div className="error-text">{strings.verificationEmailFailed}</div>
      )}
    </div>
  );
};

Verification.propTypes = {
  email: PropTypes.string.isRequired,
  strings: PropTypes.object.isRequired,
  uim: PropTypes.object.isRequired,
};

export default Verification;
